module.exports = __webpack_public_path__ + "img/marketing-team.e1f1a33f.jpg";